<template>
  <div v-if="dadosFichaTecnica.tarefas_abertas && dadosFichaTecnica.tarefas_abertas.length > 0">
    <hr>
    <div class="grid-row">
      
      <div class=" titulo-grid mt-1"  v-b-toggle.collapse-2 variant="primary">
        Tarefas Abertas

        <SGPIconComponent
          icon="mdi-chevron-down-circle"
          class="when-closed float-right"
          color="#444444"
        />
       
        <SGPIconComponent
          icon="mdi-chevron-up-circle"
          class="when-open float-right"
          color="#444444"
        />
      </div>
    </div>

    <template>
      <b-collapse id="collapse-2" class="mt-1" visible>
        <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Tarefa</th>
                <th scope="col">Bloco</th>
                <th scope="col">Código Cir</th>
                <th scope="col">CM</th>
                <th scope="col">Ponta</th>
                <th scope="col">Tipo Alteracao</th>
                <th scope="col">Cliente</th>
                <th scope="col">Designação</th>
                <th scope="col">Serviço</th>
                <th scope="col">Macro Processo</th>
                <th scope="col">Processo</th>
                <th scope="col">Status tarefa</th>
                <th scope="col">Aging</th>
                <th scope="col">Aging Útil</th>
                <th scope="col">Dados Tarefa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dadosFichaTecnica.tarefas_abertas"
                  :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td> {{ item.tarefa }}</td>
                <td> {{ item.bloco }}</td>
                <td> {{ item.cod_cir }}</td>
                <td> {{ item.cm.toUpperCase() }}</td>
                <td> {{ item.ponta.toUpperCase() }}</td>
                <td> {{ item.tipo_alteracao.toUpperCase() }}</td>
                <td> {{ item.cliente.toUpperCase() }}</td>
                <td> {{ item.designacao.toUpperCase() }}</td>
                <td> {{ item.servico.toUpperCase() }}</td>
                <td> {{ item.macro_processo }}</td>
                <td> {{ item.processo }}</td>
                <td> {{ item.status_tarefa }} </td>
                <td> {{ item.aging }}</td>
                <td> {{ item.aging_util }}</td>
                <td>
                  <a :href="getLinkFichaTecnica(item.pco_tarefa_id)">
                    <!-- <button class="btn-rounded-xs mdn-Button--global">
                      <i class="mdn-Icon-exibir"></i>
                    </button>  -->
                    <SGPFormBotaoComponent
                      fab
                      color="orange"
                      x-small
                    >
                      <SGPIconComponent
                        icon="mdi-open-in-new"
                        color="second"
                      />
                    </SGPFormBotaoComponent>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
      </b-collapse>
    </template>
 </div>  
</template>

<script>

export default {
  name: "TarefasAbertasComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },

  methods: {
    getLinkFichaTecnica(item) {
      var link = '';

      link = process.env.VUE_APP_FICHA_TECNICA_URL // '/sgp/nova-ficha-tecnica/'
      link += item
      
      return link == '' ? '#' : link;
    }
  }
  
}
</script>